export enum EInsightsIARoutes {
  Index = "insights-ia",
  AgenteDeDRE = "agente-de-dre",
  AgenteDeFluxoDeCaixa = "agente-de-fluxo-de-caixa"
}
